const ALLOWED_LINK_SCHEMES = new Set(["mailto", "https", "http", "tel", "sms", "webcal"])
const NEW_TAB_SCHEMES = new Set(["https", "http", "webcal"])
const PLACEHOLDER_PATTERN = /\{([A-Za-z0-9_-]+)\}/g
const SCHEME_PATTERN = /^([A-Za-z][A-Za-z0-9+.-]*):/
const LINK_LINE_BREAK = "\r\n"

function schemeOf(href: string): string | null {
  const match = href.match(SCHEME_PATTERN)
  return match ? match[1].toLowerCase() : null
}

function encodeAnswer(answer: string): string {
  return encodeURIComponent(answer.replace(/\r?\n/g, LINK_LINE_BREAK))
    .replace(/%40/g, "@")
    .replace(/%2C/g, ",")
}

export function buildCollectInputLinkHref(
  hrefTemplate: string,
  answerFor: (fieldId: string) => string,
): string | null {
  const scheme = schemeOf(hrefTemplate)
  if (!scheme || !ALLOWED_LINK_SCHEMES.has(scheme)) return null
  return hrefTemplate.replace(PLACEHOLDER_PATTERN, (_placeholder, fieldId: string) => encodeAnswer(answerFor(fieldId)))
}

export function collectInputLinkTarget(href: string): "_blank" | undefined {
  const scheme = schemeOf(href)
  return scheme && NEW_TAB_SCHEMES.has(scheme) ? "_blank" : undefined
}
